import { Implementer } from '../data-layer';
/**
 * Creates empty component attributes for better comparison in the tracking post-processing.
 * @returns {ComponentAttributes} preconfigured empty component attributes
 */
export function makeEmptyComponentAttributes() {
    return {
        implementer: Implementer.UNKNOWN,
        version: '',
        absoluteNumber: 1,
        instanceNumber: 1,
    };
}
